module.exports = __webpack_public_path__ + "img/popup-bg_GT.b58cc9d.png";